import Vue from 'vue';
import vuetify from '@/common/plugins/vuetify';
import i18n from '@/common/i18n';
import store from './store';
import App from './App.vue';
import { configure } from 'vee-validate';
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {id: 'UA-167963732-1'});

import { inquiryModule } from '@/contactus/store/modules/inquiry';

configure({
  // @ts-ignore
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`contact.fields.${field}`);
    return i18n.t(`validations.messages.${values._rule_}`, values);
  }
});

/* vueインスタンス */
new Vue({
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
